import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when IS_TOKEN_USAGE_ENABLED is set to "true" on the
// server. UI-only flag — the /token-usage API is always reachable; this
// hook just controls whether the tab + routes are surfaced in the UI.
export const useTokenUsageEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.features.isTokenUsageEnabled ?? false;
};
